<template>
  <section class="mb-8" v-if="visits.length">
    <div class="section-head">
      <span class="accent-dot" />
      <h2>Zuletzt angesehen</h2>
      <v-btn
        class="clear-btn"
        icon="mdi-delete-outline"
        variant="text"
        density="comfortable"
        size="small"
        aria-label="Verlauf löschen"
        @click="clearRecentVisits"/>
    </div>
    <div class="recent-chips">
      <v-chip
        v-for="visit in visits"
        :key="`${visit.type}-${visit.id}`"
        :to="routeFor(visit)"
        color="primary"
        variant="tonal"
      >
        <v-icon start size="small">{{ iconFor(visit) }}</v-icon>
        {{ labelFor(visit) }}
      </v-chip>
    </div>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import VehicleMixin from '@/mixins/VehicleMixin'

export default {
  name: 'RecentVisits',

  mixins: [VehicleMixin],

  computed: {
    ...mapState({
      recentVisits: state => state.recentVisits,
    }),

    // Defends against whatever a stored 'vuex' key might contain — an older
    // app version, a hand-edited value, or one of the malformed entries the
    // old unguarded navigation used to record (see SearchNavigationMixin).
    // A single bad entry here used to throw during render and take
    // favourites and the leaderboard down with it.
    visits: function() {
      return (this.recentVisits || []).filter(visit =>
        visit
        && (visit.type === 'train' || visit.type === 'vehicle')
        && typeof visit.id === 'string'
        && visit.id.trim() !== ''
      );
    },
  },

  methods: {
    ...mapMutations(['clearRecentVisits']),

    routeFor: function(visit) {
      return visit.type === 'train'
        ? { name: 'train', params: { trainNumber: visit.id } }
        : { name: 'vehicle', params: { vehicle: visit.id } };
    },

    iconFor: function(visit) {
      return visit.type === 'train' ? 'mdi-train' : 'mdi-tram-side';
    },

    // A vehicle id carries its own name (ICE9473 -> "Tz 9473"). A train id is
    // just a number: the router records the route parameter, and the category
    // is only known to the page once it has loaded, so "Zug 70" is what can be
    // said truthfully here.
    // "ICE 70" once the train's page has been loaded and told us its category,
    // "Zug 70" until then — which also covers an entry stored before categories
    // were recorded, and a train number that has no data at all.
    labelFor: function(visit) {
      if (visit.type !== 'train') {
        return this.prettyVehicleName(visit.id);
      }

      return visit.category
        ? `${visit.category} ${visit.id}`
        : `Zug ${visit.id}`;
    },
  },
};
</script>

<style scoped>
.recent-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 11px;
  margin: 0 4px 14px;
}
.section-head h2 {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
}
.accent-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgb(var(--v-theme-accent));
}
.clear-btn {
  margin-left: auto;
  opacity: 0.6;
}
.clear-btn:hover,
.clear-btn:focus-visible {
  opacity: 1;
}
</style>
